import type { IconData } from '@stacksjs/iconify-core'

export const ticket1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M7.444 40.543c-2.23-.166-3.913-1.762-4.12-3.99A97 97 0 0 1 3 31.369c-.035-.925.6-1.718 1.4-2.181a5.99 5.99 0 0 0 3-5.187a5.99 5.99 0 0 0-3-5.186c-.8-.464-1.435-1.257-1.4-2.181c.085-2.2.203-3.897.323-5.187c.207-2.227 1.89-3.823 4.12-3.99C10.417 7.235 15.553 7 24 7s13.583.234 16.556.457c2.23.166 3.913 1.762 4.12 3.99c.12 1.289.237 2.986.322 5.185c.036.925-.6 1.717-1.4 2.181A5.99 5.99 0 0 0 40.6 24a5.99 5.99 0 0 0 3 5.187c.8.463 1.435 1.256 1.4 2.18a97 97 0 0 1-.323 5.187c-.207 2.227-1.89 3.823-4.12 3.99c-2.973.222-8.11.456-16.556.456s-13.583-.234-16.556-.457Z\"/><path stroke-linecap=\"round\" d=\"M30 37v3.75M30 27v4m0-14v4m0-13.75V11\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ticket1
